<div [ngClass]="{'type-b': templateSuffix !== ''}">
  <div class="row">
    <div class="col-4 col-md-2 col-lg-4 col-xl-5 pr-0">
      <span class="title-text">
        <strong> Estatus </strong>
        <mat-icon [ngStyle]="{ 'color': color }"> circle </mat-icon>
      </span>
    </div>
    <div class="col-8 col-md-10 col-lg-8 col-xl-7  pl-0 ">
      <span class="text-status" [ngStyle]="{ 'color': color }"> {{ text }} </span>
    </div>
  </div>
</div>
